<template>
  <div>
    <v-container
      class="my-4 my-md-16 px-6 px-sm-16 px-md-4"
      style="max-width: 1000px"
    >
      <ValidationObserver ref="observer" v-on:keyup.enter="updatePassword">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5" align="center">
            <img
              :src="
                avatar
                  ? getImage(avatar)
                  : require('@/app/core-module/assets/images/LOGO.png')
              "
              alt="Logo"
              class="mb-10"
              height="100"
              width="auto"
            />
            <v-card elevation="0" class="border-lg">
              <div class="pa-4 pa-md-10">
                <div
                  class="
                    text-h5
                    font-weight-medium
                    textLight--text
                    mt-6
                    mb-7
                    text-start
                  "
                >
                  {{ $t("user.profile.changeYourPassword") }}
                </div>

                <validation-provider v-slot="{ errors }" rules="required">
                  <div
                    class="
                      text-start
                      mb-0
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                    "
                  >
                    {{ $t("user.profile.currentPassword") }}
                  </div>

                  <v-text-field
                    hide-details
                    v-model="currentPassword"
                    @click="errorFromApi = null"
                    :error-messages="errors"
                    outlined
                    dense
                    class="rounded-md text-body-2"
                    :append-icon="
                      currentPasswordValue ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    @click:append="
                      () => (currentPasswordValue = !currentPasswordValue)
                    "
                    :type="currentPasswordValue ? 'password' : 'text'"
                    :password_value="currentPassword"
                  >
                  </v-text-field>
                </validation-provider>

                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  vid="password"
                >
                  <div
                    class="
                      text-start
                      mb-0
                      mt-3
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                    "
                  >
                    {{ $t("user.profile.newPassword") }}
                  </div>

                  <v-text-field
                    hide-details
                    v-model="password"
                    @click="errorFromApi = null"
                    :error-messages="errors"
                    outlined
                    dense
                    class="rounded-md text-body-2"
                    :append-icon="passwordValue ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="() => (passwordValue = !passwordValue)"
                    :type="passwordValue ? 'password' : 'text'"
                    :password_value="password"
                  >
                  </v-text-field>
                </validation-provider>

                <validation-provider
                  v-slot="{ errors }"
                  rules="required|confirmed:password"
                >
                  <div
                    class="
                      text-start
                      mb-0
                      mt-3
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                    "
                  >
                    {{ $t("user.confirmPassword") }}
                  </div>

                  <v-text-field
                    hide-details
                    v-model="confirmPassword"
                    @click="errorFromApi = null"
                    :error-messages="errors"
                    outlined
                    dense
                    class="rounded-md text-body-2"
                    :append-icon="
                      confirmPasswordValue ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    @click:append="
                      () => (confirmPasswordValue = !confirmPasswordValue)
                    "
                    :type="confirmPasswordValue ? 'password' : 'text'"
                    :password_value="confirmPassword"
                  >
                  </v-text-field>
                </validation-provider>

                <v-btn
                  @click="updatePassword"
                  :loading="loading"
                  depressed
                  large
                  dark
                  class="text-subtitle-1 px-12 rounded-md mb-4 mt-8"
                  color="textLight"
                  style="width: 100%"
                >
                  {{ $t("update").toUpperCase() }}
                </v-btn>

                <p v-if="errorFromApi" class="error--text text-center">
                  {{ errorFromApi }}
                </p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import "../../core-module/util/validationRules";
import { updatePassword } from "../methods/updatePassword";

export default {
  data() {
    return {
      loading: false,
      currentPassword: null,
      password: null,
      confirmPassword: null,
      currentPasswordValue: String,
      passwordValue: String,
      confirmPasswordValue: String,
      errorFromApi: null,
    };
  },
  computed: {
    avatar() {
      return this.$store.state.authenticatedUser.avatar;
    },
  },
  methods: {
    async updatePassword() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.loading = true;

        const passwordUpdateInput = {
          currentPassword: this.currentPassword,
          newPassword: this.password,
        };

        updatePassword(passwordUpdateInput).then(response => {
          if (response.data) this.$router.push({ name: "Home" });
          else if (response.error) {
            if (response.error.includes("WRONG_PASSWORD"))
              this.errorFromApi = this.$t("user.profile.wrongPassword");
            else this.errorFromApi = this.$t("somethingWentWrong");
          }

          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped />
